import { PAGE_TITLES } from '@cockpitai/constants/pageTitles'
import { sendAccessLog } from '@cockpitai/integration/tracking/resources'
import { getDeviceType } from '@cockpitai/utils/device'
import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

export function usePageTracking() {
  const location = useLocation()
  const startTimeRef = useRef<number>(Date.now())
  const previousPathRef = useRef<string>('')
  const hasTrackedInitialPage = useRef<boolean>(false)

  useEffect(() => {
    const currentPath = location.pathname
    const previousPath = previousPathRef.current

    // Enviar tracking da página anterior quando mudar de rota
    if (previousPath && previousPath !== currentPath) {
      const durationSeconds = Math.round((Date.now() - startTimeRef.current) / 1000)

      sendAccessLog({
        pagePath: previousPath,
        pageName: PAGE_TITLES[previousPath as keyof typeof PAGE_TITLES] || 'Página Desconhecida',
        deviceType: getDeviceType(),
        durationSeconds,
      }).catch((error) => {
        console.error('Erro ao enviar tracking:', error)
      })
    }

    // Rastrear primeira visita (não tem página anterior)
    if (!hasTrackedInitialPage.current) {
      hasTrackedInitialPage.current = true
    }

    // Atualizar referências para nova página
    previousPathRef.current = currentPath
    startTimeRef.current = Date.now()

    // Cleanup: enviar tracking quando o componente desmontar ou mudar de rota
    return () => {
      // Só enviar se houver uma duração válida (evitar envios duplicados)
      const durationSeconds = Math.round((Date.now() - startTimeRef.current) / 1000)

      if (durationSeconds > 0) {
        sendAccessLog({
          pagePath: currentPath,
          pageName: PAGE_TITLES[currentPath as keyof typeof PAGE_TITLES] || 'Página Desconhecida',
          deviceType: getDeviceType(),
          durationSeconds,
        }).catch((error) => {
          console.error('Erro ao enviar tracking:', error)
        })
      }
    }
  }, [location.pathname])
}
